/** @format */

import styled from 'styled-components';

export { Select } from './Select';
export { Input } from './Input';
export { CustomSelect } from './CustomSelect';
export { TextArea } from './TextArea';

export const CustomLabel = styled.label<{ $variant: string }>`
  span {
    font-size: 0.75rem;
  }
  z-index: 1;
  --filled-transform: translateY(-100%);
  --filled-font-size: ${({ theme }) => theme.font.size['0.9375']};
  --filled-background: ${({ theme }) => theme.color.white};
  --filled-padding-inline: 0.25rem;

  color: ${({ theme }) => theme.color.teal.dark};
  font-family: ${({ theme }) => theme.font.title};
  display: inline-block;
  transition: all 0.3s ease-in-out;
  pointer-events: none;
  color: ${({ theme, $variant }) => ($variant === 'light' ? theme.color.teal.dark : theme.color.white)};
  margin-bottom: 0.375rem;
  font-size: var(--filled-font-size);
`;
